<script>
	let	blockOne = true
	let blockTwo = true
	let	blockThree = true
</script>
<section class="section dispatcher">
	<div class="container">
		<h2 class="h1 dispatcher__title b">For dispatcher</h2>
		<div class="block-informations">
			<div class="block-info block-info--1">
				<div class="block-info__column">
					<h3 class="block-info__title h3">Easy-to-Customize Driver Database</h3>
					<p class="block-info__text h5">Loder’s proprietary management system stores previously entered truck data in the database.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockOne}>Users do not need to reenter the same information over and over again and can also filter the database to find desired trucks quicker and easier.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockOne}>No more tedious typing, no more wasted time digging through files to find what you need.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockOne}>This faster and more efficient workflow saves dispatchers time and stress on the job, saving the company money over the long run.</p>
					<button class="block-info__description-open h5" on:click={() => {blockOne = !blockOne}}>
						{#if blockOne}
							Learn more <img src="../assets/icons/Arrow/Arrow_right.svg" alt="Learn more">
							{:else} 
							Close <img src="../assets/icons/Close_round.svg" alt="Close more">
						{/if}	
					</button>
				</div>
				<div class="block-info__img-container">
					<img src="../assets/img/dispatcher-1.png" alt="Easy-to-Customize Driver Database" class="block-info__img block-info__img--1">
				</div>
			</div>
			<div class="block-info block-info--2">
				<div class="block-info__column">
					<h3 class="block-info__title h3">Ready-to-Send Templated Broker Emails</h3>
					<p class="block-info__text h5">Direct contact with brokers in the Loder platform makes negotiating contracts hassle-free.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockTwo}>With Loder’s easy-to-use email integration, dispatchers can link to driver email accounts and send automated emails on their behalf.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockTwo}>Loder’s platform allows dispatchers to search and select among brokers, and while Loder automatically chooses the best rates for drivers, the dispatcher makes the final decision.</p>
					<button class="block-info__description-open h5" on:click={() => {blockTwo = !blockTwo}}>
						{#if blockTwo}
							Learn more <img src="../assets/icons/Arrow/Arrow_right.svg" alt="Learn more">
							{:else} 
							Close <img src="../assets/icons/Close_round.svg" alt="Close more">
						{/if}	
					</button>
				</div>	
				<div class="block-info__img-container">
					<img src="../assets/img/dispatcher-2.png" alt="Ready-to-Send Templated Broker Emails" class="block-info__img block-info__img--2">
				</div>
			</div>
			<div class="block-info block-info--3">
				<div class="block-info__column">
					<h3 class="block-info__title h3">Automated Monitoring Dispatch Scheduling Software</h3>
					<p class="block-info__text h5">Using Loder’s delivery monitoring software, dispatchers can easily keep track of each truck’s next scheduled event with no need for dispatchers to use a third party application or program.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockThree}>Dispatchers can easily monitor drivers’ progress during delivery runs by simply scheduling the estimated time of arrival (ETA) of loads and clicking post. Then, Loder’s computer aided dispatch software will post the cargo delivery right on schedule. From here, dispatchers will be alerted to the load delivery and ready to complete their next task.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockThree}>Keeping everything in Loder’s platform makes it easier for dispatchers to navigate between tasks without ruining their concentration or workflow. It also ensures that there is no potential for human error as Loder’s platform automatically performs the necessary task exactly on schedule. Dispatchers can enjoy a limited workload without these small, stressful things to remember, in order to complete more important tasks for the company.</p>
					<p class="block-info__text h5" class:block-info__text--hidden={blockThree}>Loder allows transportation company owners to improve dispatcher workflow and reduce company operating costs by having these small tasks automated and guaranteed to be done right. Loder gives dispatchers the tools they need to be more successful and efficient in their jobs, which in turn allows the company to run more smoothly and with a lower overhead cost.</p>
					<button class="block-info__description-open h5" on:click={() => {blockThree = !blockThree}}>
						{#if blockThree}
							Learn more <img src="../assets/icons/Arrow/Arrow_right.svg" alt="Learn more">
							{:else} 
							Close <img src="../assets/icons/Close_round.svg" alt="Close more">
						{/if}	
					</button>
				</div>
				<div class="block-info__img-container">
					<img src="../assets/img/dispatcher-3.png" alt="Automated Monitoring Dispatch Scheduling Software" class="block-info__img block-info__img--3">
					<img src="../assets/img/dispatcher-3-mobile.png" alt="Automated Monitoring Dispatch Scheduling Software" class="block-info__img block-info__img--mobile block-info__img--3">
				</div>
			</div>
		</div>
	</div>
</section>

<style>
	.section {
		padding:0 0 150px ;
		background-color: var(--system-background-primary);

	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.dispatcher__title {
		color: #FF9800;
		margin: 0;
		display: flex;
		align-items: center;
		margin-left: 52px;
	}
	.dispatcher__title::before {
		content: '';
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 10px;
		margin-right: 20px;
		background-color: #FF9800;
	}
	.block-info__title {
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 56px;
		max-width: 500px;
		margin: 0;
		color: var(--color-primary-500);
	}
	.block-info__title::before {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		background: var(--system-background-tertiary);
		border-radius: 50%;
	}
	.block-info__title::after {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		border: 5px solid var(--color-primary-500);
		border-radius: 50%;
		position: absolute;
		left: 12px;
		box-sizing: border-box;
	}
	.block-info {
		padding: 70px;
		box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.2);
		border: 2px solid rgba(242, 244, 247, 1);
		border-radius: 20px;
		margin-top: 70px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		position: relative;
		box-sizing: border-box;
		background-color: white;
	}
	.block-informations {
		position: relative;
	}
	.block-info::before {
		content: '';
		display: block;
		position: absolute;
		left: 70px;
		top: -70px;
		border-left: 1px dashed #FF9800;
		height: 70px;
	}
	.block-info:last-child {
		margin-bottom: 0;
	}
	.block-info:last-child::after {
		content: '';
		display: block;
		position: absolute;
		left: 70px;
		bottom: -150px;
		border-left: 1px dashed #FF9800;
		height: 150px;
	}
	.block-info__text {
		margin: 35px 0 20px 92px;
		max-width: 420px;
		color: var(--text-color-secondary);
	}
	.block-info__text + .block-info__text {
		margin: 0px 0px 20px 92px;
	}
	.block-info__text--hidden {
		display: none;
	}
	.block-info__description-open {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		border: 0;
		background: transparent;
		color: var(--color-primary-300);
		outline: none;
		padding: 0;
		margin: 15px 0 0 92px;
	}
	.block-info__img--mobile {
		display: none;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 1080px;
		}
		.section {
			padding: 0 0 120px;
		}
		.dispatcher__title {
			font-size: 32px;
			line-height: 40px;
		}
		.block-info__title {
			font-size: 24px;
			line-height: 30px;
			gap: 50px;
		}
		.block-info__text {
			font-size: 16px;
			line-height: 20px;
			margin-left: 86px;
			margin-top: 25px;
		}
		.block-info__text + .block-info__text {
			margin: 0px 0px 20px 86px;
		}
		.block-info__description-open {
			margin-left: 86px;
			margin-top: 5px;
		}
		.block-info {
			gap: 50px;
			padding: 60px;
			max-width: 1060px;
			margin-top: 50px;
			margin-bottom: 55px;
		}
		.block-info::before {
			height: 60px;
			top: -60px;
		}
		.block-info::after {
			height: 120px;
			bottom: -120px;
		}
		.block-info__img {
			max-width: 460px;
		}
	}
	
	@media(max-width: 960px) {
		.container {
			max-width: 755px;
		}
		.block-info {
			max-width: 735px;
			flex-direction: column;
			gap: 60px;
			width: 100%;
		}
		.block-info::before {
			height: 60px;
			top: -60px;
		}
		.block-info::after {
			height: 120px;
			bottom: -120px;
		}
		.block-info__img-container {
			margin: 0 auto -60px;
			overflow: hidden;
		}
		.block-info__img--1 {
			margin: 0 auto -130px;
		}
		.block-info__img--2 {
			margin: 0 auto -40px;
		}
		.block-info__img--3 {
			display: none;
		}
		.block-info__img--mobile {
			display: block;
			margin: 0 auto 30px;
		}
	}
	
	@media(max-width: 640px) {
		.dispatcher__title {
			font-size: 24px;
			line-height: 30px;
		}
		.container {
			max-width: 540px;
		}
		.section {
			padding: 0 0 100px;
		}
		.block-info {
			padding: 50px 30px;
			gap: 50px;
		}
		.block-info__title {
			font-size: 20px;
			line-height: 25px;
		}
		.block-info__text {
			font-size: 14px;
			line-height: 17px;
		}
		.block-info__description-open {
			font-size: 20px;
			line-height: 25px;	
		}
		.block-info__img-container {
			margin-bottom: -50px;
			width: 100%;
		}
		.block-info__img {
			width: 100%;
		}
	}

	@media(max-width: 480px) {
		.container {
			max-width: 360px;
		}
		.dispatcher__title {
			margin-left: 10px;
		}
		.dispatcher__title::before {
			width: 25px;
			height: 25px;
			border-radius: 5px;
			margin-right: 20px;
		}
		.section {
			padding: 0 0 70px ;
		}
		.block-info {
			padding: 20px;
			margin-bottom: 40px;
			margin-top: 40px;
		}
		.block-info::before {
			height: 40px;
			top: -40px;
			left: 22px;
		}
		.block-info:last-child:after {
			left: 22px;
		}
		.block-info__description-open {
			margin-left: 0;
		}
		.block-info__text {
			margin-left: 0;
		}
		.block-info__text + .block-info__text {
			margin-left: 0;
		}
		.block-info__img-container {
			margin-bottom: -20px;
		}
		.block-info__title::after, .block-info__title::before {
			display: none;
		}
	}
</style>